import { render, staticRenderFns } from "./ventajas.vue?vue&type=template&id=65cf1a90&scoped=true&"
import script from "./ventajas.vue?vue&type=script&lang=js&"
export * from "./ventajas.vue?vue&type=script&lang=js&"
import style0 from "./ventajas.vue?vue&type=style&index=0&id=65cf1a90&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf1a90",
  null
  
)

export default component.exports